@if (isStreamingEnabled) {
    <!-- Streaming view components -->
    <craig-streaming-navigation></craig-streaming-navigation>
    <craig-streaming-view></craig-streaming-view>
} @else {
    <!-- Legacy view components -->
    <craig-left-navigation></craig-left-navigation>
    <craig-chat-view></craig-chat-view>
}

<router-outlet />
